import { UI, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { FixedIncomeApplicationProps } from '../..';
import { InputMoney } from '../../../../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../../../../components/RiskRating';
import { TableContentItemText } from '../../../../../../../../../../components/TableContent';
import { FixedIncomeAssetController } from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/FixedIncome';
import { ProductCard } from '../../../../components/ProductCard';

export interface FixedIncomeInvestCardProps {
  offer: FixedIncomeApplicationProps['offer'];
  offerController: FixedIncomeAssetController;
}

export const FixedIncomeInvestCard: React.FC<FixedIncomeInvestCardProps> = ({
  offer,
  offerController,
}) => {
  const id = offer.productIdNormalized;

  const {
    control,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
    currentValueFormatted,
    selectedFee,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  } = offerController;

  return (
    <ProductCard
      infos={[
        {
          label: 'Risco',
          value: (
            <RiskRating
              currentRiskRating={Number(offer.riskRatingLevelNormalized) || 0}
              tooltip={offer.riskRatingName || ''}
            />
          ),
        },
        { label: 'IR', value: offer.incomeTaxAmountNormalized },
        {
          label: 'Rentabilidade anual',
          value: selectedFee?.profitability || offer.profitabilityFormattedNormalized,
        },
        {
          label: 'Vencimento',
          value: `${offer.maturityDateNormalized}${offer.daysToMaturityNormalized}`,
        },
        { label: 'Taxa', value: selectedFee?.customerFeeAmountFormatted || '--' },
        {
          label: 'Preço unitário',
          value: selectedFee?.customerPuAmountFormatted || offer.unitPriceNormalized || '--',
        },
        { label: 'Fee', value: selectedFee?.honorariumFee || '--' },
        { label: 'Receita estim.', value: Utils.Mask.Money(estimatedIncomeCalculated) },
        {
          label: 'Liquido estimado no vencimento',
          value: Utils.Mask.Money(estimatedNetValueCalculated),
        },
      ]}
      captions={offer.captions}
      productColor="product.rf"
      title={offer.productDisplayNormalized}
      BottomComponent={
        <VStack>
          <UI.Text color="neutral.black" variant="semibold">
            Valor a aplicar
          </UI.Text>
          <InputMoney
            id={`fixedIncome-input${id}`}
            name="createAppliedAmount"
            control={control}
            handleFocus={handleInputFocus}
            handleBlur={handleInputBlur}
            handleSubmit={handleSubmit}
            handleClear={handleInputClear}
            currentValue={currentValueFormatted}
            hasFocus={isFocused}
            minValue={offer.applicationMinimumAmount || 0}
            customInputProps={{
              ...{
                ...(showMessageAdjustUnitPrice && {
                  helpTextProps,
                  helpText,
                }),
              },
              ...{ ...(isFocused && hasError && { error: hasError }) },
              ...{ ...(isFocused && !hasError && { helpText }) },
            }}
          />
          {showMessageAdjustUnitPrice && !isFocused && (
            <TableContentItemText fontSize={Typography['fontsize.xs']} color="neutral.light">
              Ajustado por preço unitário
            </TableContentItemText>
          )}
        </VStack>
      }
    />
  );
};
